export default "__VITE_ASSET__B$NoWpk$__"